import Joyride, { type CallBackProps } from 'react-joyride';
import { joyrideLocale, joyrideStyles } from './joyrideConfig';
import { policyCreateTourSteps } from './policyCreateTourSteps';
import { useCompanyPolicyTour } from './useCompanyPolicyTour';

const TOUR_STORAGE_KEY = 'hr-company-policy-create-tour-completed';

type PolicyCreateTourProps = {
    run: boolean;
    onCallback: (data: {
        status?: string;
        type?: string;
        index?: number;
    }) => void;
};

export function PolicyCreateTour({ run, onCallback }: PolicyCreateTourProps) {
    const handleCallback = (data: CallBackProps) => {
        onCallback({ status: data.status, type: data.type, index: data.index });
    };

    return (
        <Joyride
            steps={policyCreateTourSteps}
            run={run}
            continuous
            showProgress
            showSkipButton
            callback={handleCallback}
            locale={joyrideLocale}
            styles={joyrideStyles}
            scrollToFirstStep
            scrollOffset={24}
            scrollDuration={300}
        />
    );
}

export function usePolicyCreateTour() {
    return useCompanyPolicyTour(TOUR_STORAGE_KEY);
}
